module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGb08c124320a32285f623dfb4adb6d243.b08c1243.png";